var map = {
	"./game-logo-en.png": "LvzW"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "P2zN";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nav/logo ^\.\/game\-logo\-.*\.png$
// module id = P2zN
// module chunks = 0